import './App.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import samueel from './foto/samueel.png';
import qrcode from './foto/qrcode_generate.png';
import magang1 from './foto/magang1.png';
import magang2 from './foto/magang2.png';
import desain from './foto/desain_web_e-commerce_style.png';
import onshop from './foto/onshop.png';
import listrik from './foto/pasca_listrik.png';
import weather from './foto/weather.png';
import nhkbp from './foto/nhkbp_ponkel.png';
import vigenchat from './foto/vigenchat.png';
import generateImage from './foto/generateImage.png';
import html from './foto/html.png';
import css from './foto/css.png';
import basicWeb from './foto/basic_web.png';
import js from './foto/js.png';
import ai from './foto/ai.png';
import samuel from './foto/samuel.png';
import reactCert from './foto/react.png';
import Prompt from './foto/Prompt.png';

function App() {
     useEffect(() => {
          initHeaderScroll();
          initNavLinkActive();
          initHumburgerMenu();
          initScrollAnimation();
     }, []);

     // Efek header saat scroll
     function initHeaderScroll() {
          const handleScroll = () => {
               const header = document.querySelector("header");
               if (window.scrollY > 50) {
                    header.classList.add('scrolled');
               } else {
                    header.classList.remove('scrolled');
               }
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
     }

     function initNavLinkActive() {
          const handleScroll = () => {
               const sections = document.querySelectorAll('section');
               const navLinks = document.querySelectorAll('.nav-link');
               let current = '';

               sections.forEach(section => {
                    const sectionTop = section.offsetTop;
                    const sectionHeight = section.clientHeight;

                    if (window.scrollY >= sectionTop - 200) {
                         current = section.getAttribute('id');
                    }
               });

               navLinks.forEach(link => {
                    link.classList.remove('active');
                    if (link.getAttribute('href') === `#${current}`) {
                         link.classList.add('active');
                    }
               });
          };
          
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
     }

     // Hamburger menu untuk mobile
     function initHumburgerMenu() {
          const hamburger = document.querySelector('.hamburger');
          const navMenu = document.querySelector('nav ul');
          const navLinks = document.querySelectorAll('.nav-link');

          if (hamburger) {
               hamburger.addEventListener('click', () => {
                    hamburger.classList.toggle('active');
                    navMenu.classList.toggle('active');
               });

               navLinks.forEach(link => {
                    link.addEventListener('click', () => {
                         hamburger.classList.remove('active');
                         navMenu.classList.remove('active');
                    });
               });
          }
     }

     function initScrollAnimation() {
          const animItems = document.querySelectorAll('.project-card, .skill-category, .stat-item, .section-title, .about-text, .contact-form');

          function checkScroll() {
               animItems.forEach(item => {
                    const itemTop = item.getBoundingClientRect().top;
                    const windowHeight = window.innerHeight;

                    if (itemTop < windowHeight - 100) {
                         item.classList.add('animate');
                    }
               });
          }

          // Class CSS Untuk Animasi
          animItems.forEach(item => {
               item.classList.add('fade-in');
          });

          // periksa scroll saat halaman dibuat
          window.addEventListener('load', checkScroll);

          // Periksa  scroll saat user scroll
          window.addEventListener('scroll', checkScroll);
     }


     return (
          <>
          <div className="background-animation">
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
               <div className="cube"></div>
          </div>
               <header>
               <div className="container">
                    <div className="logo">SAMUEL EBIT NEGO</div>          
               </div>
                    <nav>
                         <ul>
                              <li><a href="#home" class="nav-link active">Home</a></li> 
                              <li><a href="#about" class="nav-link">About</a></li>
                              <li><a href="#skills" class="nav-link">Skills</a></li>
                              <li><a href="#projects" class="nav-link">Projects</a></li>
                              <li><a href="#certificate" class="nav-link">Certificate</a></li>
                              <li><a href="#contact" class="nav-link">Contact</a></li>
                         </ul>
                    </nav>
                    <div className="hamburger">
                         <span className="bar"></span>
                         <span className="bar"></span>
                         <span className="bar"></span>
                    </div>
               </header>
                    <section id="home" className="section">
                         <div className="container">
                              <div className="hero-content">
                                   <h1>Samuel Ebit Nego</h1>
                                   <p className="subtitle">Web Developer | Front-End Developer</p>
                                   <p className="description">Menciptakan pengalaman web yang memukau dengan fokus pada performa dan desain yang intuitif</p>
                                   <div className="cta-button">
                                        <a href="#contact" className="btn primary-btn">Hubungi Saya</a>
                                        <a href="#project" className="btn primary-btn">Lihat Karya</a>
                                   </div>
                              </div>
                              <div className="hero-image">
                                   <img src={samuel} alt="Samuel Ebit Nego" className="profile-img" />
                              </div>
                         </div>
                    </section>
                    <section id="about" className="section">
                         <div className="container">
                              <h2 className="section-title">Tentang Saya</h2>
                              <div className="about-content">
                                   <div className="about-text">
                                        <p>Samuel Ebit Nego, lulusan baru jurusan Sistem Informasi dari Universitas Bina Sarana Informatika. Saya membangun 10 proyek berbasis situs web.</p>
                                        <p>Saya ahli dalam desain responsif, arsitektur basis data, dan desain Plantuml. Saya cepat belajar dan mampu bekerja dengan teknologi terkini, dan saya siap untuk posisi Front-End Web atau Full Stack Web Developer.</p>
                                   </div>
                                   <div className="about-stats">
                                        <div className="stat-item">
                                             <span className="stat-number">3+</span>
                                             <span className="stat-text">Tahun Pengalaman</span>
                                        </div>
                                        <div className="stat-item">
                                             <span className="stat-number">10</span>
                                             <span className="stat-text">Project Selesai</span>
                                        </div>
                                        <div className="stat-item">
                                             <span className="stat-number">7</span>
                                             <span className="stat-text">Sertifikat</span>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </section>
                    <section id="skills">
                         <div className="container">
                              <h2 className="section-title">Keahlian</h2>
                              <div className="skills-container">
                                   <div className="skill-category">
                                        <h3>Design</h3>
                                        <div className="skills-grid">
                                             <div className="skill-item">
                                                  <i className="fab fa-figma"></i>
                                                  <span>Figma</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fas fa-paint-brush"></i>
                                                  <span>UI/UX</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fab fa-html5"></i>
                                                  <span>HTML5</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fab fa-css3-alt"></i>
                                                  <span>CSS3</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fab fa-js"></i>
                                                  <span>JavaScript</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fab fa-bootstrap"></i>
                                                  <span>Bootstrap</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fab fa-react"></i>
                                                  <span>React</span>
                                             </div>
                                        </div>
                                   </div>
                                    <div className="skill-category">
                                        <h3>Tools</h3>
                                        <div className="skills-grid">
                                             <div className="skill-item">
                                                  <i className="fab fa-git-alt"></i>
                                                  <span>Git</span>
                                             </div>
                                             <div className="skill-item">
                                                  <i className="fab fa-npm"></i>
                                                  <span>npm</span>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </section>
                    <section id="projects" className="section">
                         <div className="container">
                              <h2 className="section-title">Proyek</h2>
                              <div className="projects-grid">
                                   <div className="project-card">
                                        <div className="project-image">
                                             <img src={generateImage} alt="generateImage" />
                                        </div>
                                         <div className="project-info">
                                             <h3>Image Generate</h3>
                                             <p>Image Generate berbasis website</p>
                                             <div className="project-tags">
                                                  <span>React</span>
                                                  <span>JavaScript</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://generate-image-ten.vercel.app/" className="btn small-btn">Demo</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                             <img src={magang2} alt="magang2" />
                                        </div>
                                         <div className="project-info">
                                             <h3>Pembaruan Update Fitur & UI Pengembangan Sistem Tata Kelola Surat Dinas Kominfotik Jakarta Timur</h3>
                                             <p>List Arsip Surat dibuat pada saat PKL/Magang</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                                  <span>PHP</span>
                                                  <span>Bootstrap SB2-Admin</span>
                                                  <span>Laravel 10</span>
                                                  <span>MySQL</span>
                                             </div>
                                             <div className="project-links">
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                             <img src={magang1} alt="magang1" />
                                        </div>
                                         <div className="project-info">
                                             <h3>Pengembangan Sistem Tata Kelola Surat Dinas Kominfotik Jakarta Timur</h3>
                                             <p>List Arsip Surat dibuat pada saat PKL/Magang</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                                  <span>PHP</span>
                                                  <span>Bootstrap SB2-Admin</span>
                                                  <span>Laravel 10</span>
                                                  <span>MySQL</span>
                                             </div>
                                             <div className="project-links">
                                             </div>
                                        </div>
                                   </div>
                                        <div className="project-card">
                                        <div className="project-image">
                                             <img src={qrcode} alt="QR Code Generate" />
                                        </div>
                                        <div className="project-info">
                                             <h3>QR Code Generate</h3>
                                             <p>Ketik generate dengan tulisan maka hasil QR Code akan muncul.</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://qrcodegenerate-three.vercel.app/" className="btn small-btn">Demo</a>
                                                  <a href="https://github.com/SamuelEbitNego/qrcodegenerate" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                        <img src={desain} alt="Web Desain E-commerce Style" />
                                        </div>
                                        <div className="project-info">
                                             <h3>Web Desain E-commerce Style</h3>
                                             <p>Tugas Project Kuliah Membuat Tampilan Desain Web.</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://tampilan-aplikasi.vercel.app/" className="btn small-btn">Demo</a>
                                                  <a href="https://github.com/SamuelEbitNego/tampilan-aplikasi" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                        <img src={onshop} alt="Web Aplikasi Belanja Onshop" />
                                        </div>
                                        <div className="project-info">
                                             <h3>Web Aplikasi Belanja Onshop</h3>
                                             <p>Tugas Project Kuliah UAS Framework Bootstrap & Codeigniter 3 (CRUD)</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                                  <span>Bootstrap & Codeigniter 3</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://github.com/SamuelEbitNego/onshopp" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                             <img src={listrik} alt="Web Pembayaran Pasca Listrik" />
                                        </div>
                                        <div className="project-info">
                                             <h3>Web Pembayaran Pasca Listrik</h3>
                                             <p>Tugas Project BNSP Sertifikat Framework Bootstrap & Codeigniter 3 (CRUD)</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                                  <span>Bootstrap & Codeigniter 3</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://github.com/SamuelEbitNego/listrik" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                             <img src={weather} alt="Weather App" />
                                        </div>
                                        <div className="project-info">
                                             <h3>Weather App</h3>
                                             <p>Weather App Menggunakan React</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                                  <span>React</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://weather-app-silk-seven-93.vercel.app/" className="btn small-btn">Demo</a>
                                                  <a href="https://github.com/SamuelEbitNego/weather-app" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                             <img src={nhkbp} alt="NHKBP Pondok Kelapa" />
                                        </div>
                                        <div className="project-info">
                                             <h3>Compony Profile Naposo HKBP Pondok Kelapa</h3>
                                             <p>Web Portofolio Gereja</p>
                                             <div className="project-tags">
                                                  <span>HTML</span>
                                                  <span>CSS</span>
                                                  <span>JavaScript</span>
                                                  <span>Bootstrap</span>
                                             </div>
                                             <div className="project-links">
                                                  <a href="https://rnhkbppondokkelapa.vercel.app/" className="btn small-btn">Demo</a>
                                                  <a href="https://github.com/SamuelEbitNego/rnhkbppondokkelapa" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                                   <div className="project-card">
                                        <div className="project-image">
                                        <img src={vigenchat} alt="Vigenchat" />
                                        </div>
                                        <div className="project-info">
                                             <h3>Mobile Apps Vigenchat</h3>
                                             <p>Tugas Project UAS Membuat Mobile Apps</p>
                                             <div className="project-tags">
                                                  <span>Flutter</span>
                                                  <span>Supabase</span>
                                             </div>
                                             <div className="project-links">
                                              <a href="https://github.com/SamuelEbitNego/vigenchat" className="btn small-btn outline">Code</a>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              
                              <div className="center-btn">
                                   <a href="#" className="btn secondary-btn">Lihat Semua Proyek</a>
                              </div>
                         </div>
                    </section>
                <section id="certificate" className="section certificate">
               <div className="container">
                    <h2 className="section-title">Certificate</h2>
                    <div className="projects-grid">
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={Prompt} alt="Prompt Engineering" />
                              </div>
                              <div class="project-info">
                                   <h3>Belajar Prompt Engineering</h3>
                                   <p>Prompt Engineering Software Developer</p>
                                   <div class="project-tags">
                                        <span>Materi</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/1psjBMLABPH5cnWkfHNfkNbG6Uh2BDkyB/view?usp=sharing" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={html} alt="HTML Course" />
                              </div>
                              <div class="project-info">
                                   <h3>HTML Course</h3>
                                   <p>Sololearn Course HTML</p>
                                   <div class="project-tags">
                                        <span>HTML</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/19MR-dAmbzF18eieAhLwvo3vTXEpyf4W1/view" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={css} alt="CSS Course" />
                              </div>
                              <div class="project-info">
                                   <h3>CSS Course</h3>
                                   <p>Sololearn CSS Course.</p>
                                   <div class="project-tags">
                                        <span>CSS</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/1PLNmLOhdiLfwB-eX3YeByqEFnl8D5bPi/view" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={basicWeb} alt="Belajar Dasar Web" />
                              </div>
                              <div class="project-info">
                                   <h3>Belajar Dasar Web</h3>
                                   <p>Belajar Dasar Web Pemogramman Dicoding</p>
                                   <div class="project-tags">
                                        <span>HTML</span>
                                        <span>CSS</span>
                                        <span>JavaScript</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/1JZJ_-UnlJ_Ce3VzPpBk37arikoQzvor9/view" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={js} alt="Belajar Dasar JavaScript" />
                              </div>
                              <div class="project-info">
                                   <h3>JavaScript Program Basic</h3>
                                   <p>Belajar Dasar JavaScript Dicoding</p>
                                   <div class="project-tags">
                                        <span>HTML</span>
                                        <span>CSS</span>
                                        <span>JavaScript</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/1d0scf_zo-EJZcnxZJJziGoomT7jd2kSs/view" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={ai} alt="Belajar Dasar AI" />
                              </div>
                              <div class="project-info">
                                   <h3>Belajar Dasar AI</h3>
                                   <p>Belajar Dasar AI Dicoding</p>
                                   <div class="project-tags">
                                        <span>AI</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/1eOxd42wMdO36PWgh-xgKbS3Qi8eklUu1/view" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         <div class="project-card">
                              <div class="project-image">
                                   <img src={reactCert} alt="Belajar Membuat Aplikasi Web dengan React" />
                              </div>
                              <div class="project-info">
                                   <h3>Belajar Membuat Aplikasi Web dengan React</h3>
                                   <p>Weather App Menggunakan React</p>
                                   <div class="project-tags">
                                        <span>HTML</span>
                                        <span>CSS</span>
                                        <span>JavaScript</span>
                                        <span>React</span>
                                   </div>
                                   <div class="project-links">
                                        <a href="https://drive.google.com/file/d/1K34Eep_n8xQbRC0zHovc95fUK2IR7uj1/view" class="btn small-btn outline">Visit</a>
                                   </div>
                              </div>
                         </div>
                         </div>
                    </div>
               </section>
               <section id="contact" className="section">
               <div className="container">
                    <h2 className="section-title">Hubungi Saya</h2>
                    <div className="contact-container">
                         <div className="contact-info">
                              <p>Tertarik bekerja sama? Hubungi saya melalui formulir atau langsung melalui:</p>
                              <div className="contact-details">
                                   <div className="contact-item">
                                        <i className="fas fa-envelope"></i>
                                        <a href="mailto:samuelebitnego13@gmail.com">samuelebitnego13@gmail.com</a>
                                   </div>
                                   <div className="contact-item">
                                        <i className="fas fa-phone"></i>
                                        <a href="tel:+62895613180888">+62-895-6131-80888</a>
                                   </div>
                              </div>
                              <div className="social-links">
                                   <a href="https://github.com/SamuelEbitNego" className="social-icon"><i className="fab fa-github"></i></a>
                                   <a href="https://www.linkedin.com/in/samuel-ebit-nego-6934002a9/" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
                                   <a href="https://www.instagram.com/samuel_ebit13/" className="social-icon"><i className="fab fa-instagram"></i></a>
                              </div>
                         </div>
                         <form className="contact-form">
                              <div className="form-group">
                                   <label htmlFor="name">Nama</label>
                                   <input type="text" id="name" name="name" required />
                              </div>
                              <div className="form-group">
                                   <label htmlFor="email">Email</label>
                                   <input type="email" id="email" name="email" required />
                              </div>
                              <div className="form-group">
                                   <label htmlFor="message">Pesan</label>
                                   <textarea id="message" name="message" rows="5" required></textarea>
                              </div>
                              <button type="submit" className="btn primary-btn">Kirim Pesan</button>
                         </form>
                    </div>
               </div>
               </section>
                <footer>
          <div className="container">
               <div className="footer-content">
                    <p>Membangun pengalaman web</p>
                    <div className="footer-social">
                         <a href="https://github.com/SamuelEbitNego" className="social-icon"><i className="fab fa-github"></i></a>
                         <a href="https://www.linkedin.com/in/samuel-ebit-nego-6934002a9/" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
                         <a href="https://www.instagram.com/samuel_ebit13/" className="social-icon"><i className="fab fa-instagram"></i></a>
                    </div>
               </div>
               <div className="footer-bottom">
                    <p>&copy; 2025 Samuel Ebit Nego. All rights reserved.</p>
               </div>
          </div>
     </footer>
          </>
     );
}
export default App;
